import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'react-jss';
import { createMemoStyles, safeRest, defaultBaseline, uniqueId } from '@wds/utils';
import { IconCheck, IconCaretDown } from '@wds/icons';
import { Menu } from '@wds/menu';

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var useStyles$1 = createMemoStyles(function (theme) {
  var type = theme.type,
      spacing = theme.spacing,
      palette = theme.palette;
  return {
    wrenchLabel: function wrenchLabel(_ref) {
      var muted = _ref.muted,
          plain = _ref.plain;
      return _objectSpread$1(_objectSpread$1({
        display: 'block',
        color: palette.text.dark,
        fontFamily: type.fontFamily.base,
        '-webkit-font-smoothing': 'antialiased',
        boxSizing: 'border-box',
        fontSize: type.fontSize.bodySm,
        padding: 0,
        margin: [0, 0, spacing[2]],
        fontWeight: type.fontWeight.medium
      }, plain && {
        fontWeight: type.fontWeight.regular,
        fontSize: type.fontSize.body
      }), muted && {
        color: palette.text.darkMuted,
        fontWeight: type.fontWeight.regular
      });
    }
  };
});
var useStyles$2 = useStyles$1;
var _excluded$2 = ["children", "htmlFor", "muted", "plain"];

var Label = function Label(_ref) {
  var children = _ref.children,
      htmlFor = _ref.htmlFor,
      muted = _ref.muted,
      plain = _ref.plain,
      rest = _objectWithoutProperties(_ref, _excluded$2);

  var theme = useTheme();

  var _useStyles = useStyles$2({
    theme: theme,
    muted: muted,
    plain: plain
  }),
      wrenchLabel = _useStyles.wrenchLabel;

  return /*#__PURE__*/React.createElement("label", Object.assign({
    className: wrenchLabel,
    htmlFor: htmlFor
  }, safeRest(rest)), children);
};

Label.displayName = "Label";
Label.propTypes = {
  children: PropTypes.string.isRequired,
  htmlFor: PropTypes.string.isRequired,
  muted: PropTypes.bool,
  plain: PropTypes.bool
};
Label.defaultProps = {
  muted: false,
  plain: false
};
var Label$1 = Label;

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var SIZES = /* #__PURE__ */Object.freeze(['lg', 'md', 'sm']);
/* #__PURE__ */

Object.freeze([].concat(_toConsumableArray(SIZES), ['xs']));
var INPUT_COLORS = /* #__PURE__ */Object.freeze(['success', 'warning', 'error']);
var _excluded$1 = ["children", "disabled", "value"];

var SelectOption = function SelectOption(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, _excluded$1);

  return /*#__PURE__*/React.createElement("div", Object.assign({
    disabled: disabled,
    value: value
  }, safeRest(rest)), children);
};

SelectOption.displayName = "SelectOption";
SelectOption.propTypes = {
  /**
   * Option display label
   */
  children: PropTypes.node.isRequired,

  /**
   * If true, option value is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Value for Option
   */
  value: PropTypes.string.isRequired
};
SelectOption.defaultProps = {
  disabled: false
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var useStyles = createMemoStyles(function (theme) {
  var palette = theme.palette,
      border = theme.border,
      shadow = theme.shadow,
      spacing = theme.spacing,
      radius = theme.radius,
      type = theme.type;
  var select = {
    height: {
      sm: 32,
      md: 40,
      lg: 48
    },
    borderRadius: radius.small,
    iconColor: palette.muted.contrast,
    fontSize: type.fontSize.body
  };
  return {
    wrenchSelectMenuContainer: function wrenchSelectMenuContainer(_ref) {
      var color = _ref.color,
          size = _ref.size,
          disabled = _ref.disabled,
          stretched = _ref.stretched;
      return {
        position: 'relative',
        display: 'inline-block',
        cursor: 'pointer',
        boxSizing: 'border-box',
        backgroundColor: palette.background.light,
        border: border.main,
        borderColor: color && palette[color].main,
        fontSize: select.fontSize,
        color: palette.text.dark,
        borderRadius: select.borderRadius,
        pointerEvents: disabled && 'none',
        opacity: disabled && '0.4',
        width: stretched && '100%',
        maxWidth: '100%',
        height: select.height[size],
        flexGrow: '1',
        '&:hover': {
          borderColor: color ? palette[color].main : palette.border.hover,
          boxShadow: shadow.sky,
          transition: ['all', '100ms']
        },
        '&:focus, &:focus-within': {
          borderColor: color ? palette[color].main : palette.border.active,
          transition: ['border-color', '100ms'],
          outline: '0'
        },
        '& > span': {
          position: 'initial',
          flexGrow: '1',
          width: '100%',
          '& > [role="listbox"]': {
            maxWidth: 'none',
            marginTop: 1
          }
        },
        '& > span > [role="listbox"] [role="option"] > span': {
          pointerEvents: 'none',
          // don't steal click event from parent
          '& > svg': {
            marginRight: spacing[2]
          }
        },
        '& > span > [role="listbox"] [role="option"] > div': {
          pointerEvents: 'none' // don't steal click event from parent

        }
      };
    },
    wrenchSelectMenu: function wrenchSelectMenu(_ref2) {
      var size = _ref2.size,
          addOn = _ref2.addOn;
      return _objectSpread(_objectSpread({}, defaultBaseline), {}, {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: select.height[size],
        fontSize: select.fontSize,
        cursor: 'pointer',
        padding: [0, spacing[7], 0, spacing[4]],
        paddingLeft: addOn && "".concat(spacing[6] + spacing[2], "px")
      });
    },
    wrenchSelectMenuSelectedItem: function wrenchSelectMenuSelectedItem() {
      return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '& > svg': {
          marginRight: spacing[2]
        }
      };
    },
    wrenchSelectMenuNonSelectedItemLeft: function wrenchSelectMenuNonSelectedItemLeft() {
      return {
        width: spacing[4],
        height: spacing[4]
      };
    },
    wrenchSelectMenuAffordance: function wrenchSelectMenuAffordance() {
      return {
        position: 'absolute',
        top: '50%',
        right: spacing[4],
        transform: 'translateY(-0.75em)',
        pointerEvents: 'none',
        width: '1em',
        height: '1em',
        '& > svg': {
          fill: select.iconColor
        }
      };
    },
    wrenchSelectMenuAddOn: function wrenchSelectMenuAddOn() {
      return _objectSpread(_objectSpread({}, defaultBaseline), {}, {
        fontFamily: type.fontFamily.base,
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-0.75em)',
        left: 16,
        paddingRight: spacing[3],
        pointerEvents: 'none' // don't steal click event from parent

      });
    }
  };
});
var _excluded = ["children", "id", "label", "placeholder", "ariaLabel", "disabled", "color", "value", "size", "stretched", "name", "onChange", "addOn", "selectedPlacement", "placement", "renderTo", "elevation"];
var SELECTMENU_SIZES = ['sm', 'md', 'lg'];
var SELECTMENU_PLACEMENTS = ['bottom-right', 'bottom-left', 'top-right', 'top-left'];

var SelectMenu = function SelectMenu(_ref) {
  var children = _ref.children,
      id = _ref.id,
      label = _ref.label,
      placeholder = _ref.placeholder;
  _ref.ariaLabel;
  var disabled = _ref.disabled,
      color = _ref.color,
      value = _ref.value,
      size = _ref.size,
      stretched = _ref.stretched;
  _ref.name;

  var onChange = _ref.onChange,
      addOn = _ref.addOn,
      selectedPlacement = _ref.selectedPlacement,
      placement = _ref.placement,
      renderTo = _ref.renderTo,
      elevation = _ref.elevation,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(React.Children.toArray(children)),
      _useState2 = _slicedToArray(_useState, 1),
      options = _useState2[0];

  var inputID = useMemo(function () {
    return id || uniqueId('input');
  }, [id]);

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showMenu = _useState4[0],
      setShowMenu = _useState4[1];

  var _useState5 = useState(placeholder),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedItem = _useState6[0],
      setSelectedItem = _useState6[1];

  var _useState7 = useState(value),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedValue = _useState8[0],
      setSelectedValue = _useState8[1];

  var theme = useTheme();
  var classes = useStyles({
    size: size,
    color: color,
    disabled: disabled,
    stretched: stretched,
    addOn: addOn,
    theme: theme
  });

  var handleMenuChange = function handleMenuChange() {
    setShowMenu(false);
  };

  var displaySelectedItem = function displaySelectedItem(props) {
    var child = props.children;
    return /*#__PURE__*/React.createElement(React.Fragment, null, props.selectedValue || (child.props ? child.props.children : child));
  };

  var updateValues = function updateValues(updatedValue) {
    setSelectedValue(updatedValue);
    var item = options.find(function (child) {
      return child.props.value === updatedValue.toString();
    });
    var newSelectedItem = displaySelectedItem(item.props);
    setSelectedItem(newSelectedItem);
  };

  useEffect(function () {
    if (value !== undefined) {
      updateValues(value);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [value]);

  var clickMenuItem = function clickMenuItem(e) {
    var optionValue = e.target.attributes.value.nodeValue;
    e.persist();
    updateValues(optionValue);
    handleMenuChange();

    if (onChange) {
      onChange(e);
    }
  };

  var getMenuItem = function getMenuItem(child, index, selected) {
    var menuItemId = "select-child-".concat(index);
    var _child$props = child.props,
        childsChildren = _child$props.children,
        icon = _child$props.icon,
        childValue = _child$props.value;
    return /*#__PURE__*/React.createElement(Menu.Item, {
      key: id,
      id: menuItemId,
      disabled: child.props.disabled,
      value: childValue,
      onClick: function onClick(e) {
        return clickMenuItem(e);
      },
      addOn: selected ? /*#__PURE__*/React.createElement("span", {
        className: "select__checked"
      }, /*#__PURE__*/React.createElement(IconCheck, {
        title: "Check mark icon",
        color: "success"
      })) : !!selectedValue && selectedPlacement === 'left' && /*#__PURE__*/React.createElement("span", {
        className: classes.wrenchSelectMenuNonSelectedItemLeft
      }),
      addOnPlacement: selectedPlacement,
      role: "option"
    }, icon, childsChildren);
  };

  var menuItems = React.Children.map(options, function (child, index) {
    var props = child.props;
    var isSelected = selectedValue === props.value;
    return getMenuItem(child, index, isSelected);
  });
  var selectMenu = /*#__PURE__*/React.createElement("div", {
    className: classes.wrenchSelectMenu
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.wrenchSelectMenuSelectedItem
  }, selectedItem), /*#__PURE__*/React.createElement("div", {
    className: classes.wrenchSelectMenuAffordance
  }, /*#__PURE__*/React.createElement(IconCaretDown, {
    title: "Dropdown icon"
  })));
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!label ? /*#__PURE__*/React.createElement(Label$1, {
    htmlFor: inputID
  }, label) : null, /*#__PURE__*/React.createElement("div", Object.assign({
    id: inputID,
    className: classes.wrenchSelectMenuContainer,
    tabIndex: -1,
    role: "button",
    "aria-haspopup": "listbox",
    "aria-expanded": showMenu
  }, safeRest(rest)), addOn ? /*#__PURE__*/React.createElement("div", {
    className: classes.wrenchSelectMenuAddOn
  }, addOn) : null, /*#__PURE__*/React.createElement(Menu, {
    dense: true,
    noRules: true,
    menuTrigger: selectMenu,
    placement: placement,
    show: showMenu,
    onChange: handleMenuChange,
    role: "listbox",
    renderTo: renderTo,
    elevation: elevation
  }, menuItems)));
};

SelectMenu.propTypes = {
  /**
   * Add options with SelectMenu.Option
   */
  children: PropTypes.node.isRequired,

  /**
   * identifier for input component
   */
  id: PropTypes.string,

  /**
   * Label for component, aria-label is not required to be defined if this is
   */
  label: PropTypes.node,

  /**
   * If value is null, placeholder will be displayed if defined
   */
  placeholder: PropTypes.node,

  /**
   * Aria Label for component
   */
  ariaLabel: PropTypes.node,

  /**
   Name value of the component 
  */
  name: PropTypes.string,

  /**
   * If true will disable select from being used
   */
  disabled: PropTypes.bool,

  /**
   * Colors the border of component
   */
  color: PropTypes.oneOf(INPUT_COLORS),

  /**
   * Value of input component
   */
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.number]),

  /**
   * Callback fired when state is changed
   * function(event: object) => void
   */
  onChange: PropTypes.func,

  /**
   * Size options for component
   */
  size: PropTypes.oneOf(SELECTMENU_SIZES),

  /**
   * If true will fit the full width of parent container
   */
  stretched: PropTypes.bool,

  /**
   * Add-on will be added to the left of the selection, useful for adding
   * additional icons, etc.
   */
  addOn: PropTypes.node,

  /**
   * Placement of the checkmark added upon item selection from menu, default will be left
   */
  selectedPlacement: PropTypes.oneOf(['left', 'right']),

  /**
   * Placement of the options menu
   */
  placement: PropTypes.oneOf(SELECTMENU_PLACEMENTS),

  /**
   *  You may want to render the SelectMenu attached to a parent element so that it can be rendered outside of the trigger container.
   */
  renderTo: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.elementType
  })]),

  /**
   * If provided, overrides the z-index value of the component
   */
  elevation: PropTypes.number
};
SelectMenu.defaultProps = {
  id: undefined,
  label: undefined,
  placeholder: 'Choose...',
  name: undefined,
  disabled: false,
  color: undefined,
  value: undefined,
  onChange: undefined,
  size: 'md',
  stretched: false,
  ariaLabel: undefined,
  addOn: undefined,
  selectedPlacement: 'left',
  placement: 'bottom-left',
  renderTo: undefined,
  elevation: undefined
};
SelectMenu.Option = SelectOption;
export { SelectMenu };